import { render, staticRenderFns } from "./DataSection.vue?vue&type=template&id=5078d1fd&scoped=true"
import script from "./DataSection.vue?vue&type=script&lang=js"
export * from "./DataSection.vue?vue&type=script&lang=js"
import style0 from "./DataSection.vue?vue&type=style&index=0&id=5078d1fd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5078d1fd",
  null
  
)

export default component.exports